import {useState} from 'react';

import {Grid, Box, Hidden} from '@mui/material';
import {useMeasure} from '@uidotdev/usehooks';
import {array, func, node} from 'prop-types';

import OpenOverflowedTabsMenuButton from '../OpenOverflowedTabsMenuButton';

const OverflowedTabs = ({overflowedItems, rightToolbar, children, renderMenu}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [rightToolbarRef, {width: rightToolbarWidth}] = useMeasure();

  const showOverflowButton = overflowedItems.length > 0;

  return (
    <>
      <Grid container alignItems="center" flexWrap="wrap" sx={{width: '100%'}}>
        <Hidden only="xs">
          <Box ml={1} sx={{width: rightToolbarWidth}} />
        </Hidden>
        <Hidden smUp>
          <Box ml={5} />
        </Hidden>

        <Box
          sx={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            overflow: 'hidden',
            minWidth: 0
          }}
        >
          {children}
        </Box>

        <Grid item>
          <Grid container alignItems="center" flexWrap="nowrap" ref={rightToolbarRef}>
            {showOverflowButton && (
              <OpenOverflowedTabsMenuButton
                onClick={e => {
                  setAnchorEl(e.currentTarget);
                  setMenuOpen(true);
                }}
              />
            )}
            {rightToolbar}
          </Grid>
        </Grid>
      </Grid>

      {renderMenu &&
        renderMenu({
          anchorEl,
          isOpen: menuOpen,
          onClose: () => setMenuOpen(false),
          overflowedItems
        })}
    </>
  );
};

OverflowedTabs.propTypes = {
  overflowedItems: array,
  children: node.isRequired,
  renderMenu: func.isRequired,
  rightToolbar: node.isRequired
};

export default OverflowedTabs;
